import { render, staticRenderFns } from "./TwitterInfor.vue?vue&type=template&id=47d9efa0&scoped=true"
import script from "./TwitterInfor.vue?vue&type=script&lang=ts"
export * from "./TwitterInfor.vue?vue&type=script&lang=ts"
import style0 from "./TwitterInfor.vue?vue&type=style&index=0&id=47d9efa0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d9efa0",
  null
  
)

export default component.exports